type ParisNowParts = {
    year: number;
    month: number;
    day: number;
    hour: number;
};

export const getParisNowParts = (d = new Date()): ParisNowParts => {
    const parts = new Intl.DateTimeFormat("fr-FR", {
        timeZone: "Europe/Paris",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        hour12: false,
    }).formatToParts(d);
    const get = (type: string) => Number(parts.find((p) => p.type === type)?.value);
    return {
        year: get("year"),
        month: get("month"),
        day: get("day"),
        hour: get("hour"),
    };
};

export const prevMonth = (year: number, month: number) => {
    if (month === 1) {
        return {year: year - 1, month: 12};
    }
    return { year, month: month - 1 };
};
